export const OCCUPANCY = 'OCCUPANCY'
export const BILLING = 'BILLING'
export const SMART_ALERTS_DISABLED = 'SMART_ALERTS_DISABLED'
export const SMART_ALERT = 'SMART_ALERT'
